import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';
import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Header";
import HeaderWhite from "../Components/Header/HeaderWhite";
import { homePage } from "../actions/ApiCalls";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import './app.css';
import {IMAGE_URL} from "../path";
import { useNavigate } from "react-router-dom";
import UrgentAlert from "../Components/UrgentNotice/FraudNotice20251014";

type ImageItem = {
    image_path: string;
    mobile_image_path: string;
    title: string;
    link: string;
};

function Home() {
    const [isAtTop, setIsAtTop] = useState(true);
    const [images, setImages] = useState<ImageItem[]>([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [swiperInstance, setSwiperInstance] = useState<SwiperType | null>(null);

    const imageUrl = IMAGE_URL;
    const navigate = useNavigate();

    useEffect(() => {
        homePage()
            .then(response => setImages(response.data))
            .catch(error => console.error("Failed to fetch home images:", error));
    }, []);

    useEffect(() => {
        const handleScroll = () => setIsAtTop(window.scrollY === 0);
        const handleResize = () => setIsMobile(window.innerWidth <= 768);

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);

        handleScroll();
        handleResize();

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const goToPrevious = () => swiperInstance?.slidePrev();
    const goToNext = () => swiperInstance?.slideNext();

    const getImagePath = (img: ImageItem) =>
        `${imageUrl}${isMobile ? img.mobile_image_path : img.image_path}`;



    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }}>
            {/* Dynamic Header */}
            <div className="header-container">
                {isAtTop ? <HeaderWhite /> : <Header />}
            </div>
            {/*<UrgentAlert />*/}
            <div style={{ flex: '1' }}>
                <div className="carousel">
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        spaceBetween={0}
                        slidesPerView={1}
                        autoplay={{ delay: 2500, disableOnInteraction: false }}
                        speed={400}
                        loop={true}
                        grabCursor={true}
                        onSwiper={setSwiperInstance}
                        style={{
                            height: window.innerWidth > 575 ? '100vh' : '90vh',
                            touchAction: 'pan-y',
                            position: 'relative',
                        }}
                    >
                        {images.map((img, index) => {
                            const imagePath = getImagePath(img);


                            return (
                                <SwiperSlide key={index}>
                                    <div
                                        className="carousel-slide"
                                        style={{
                                            backgroundImage: `url(${imagePath})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            width: '100%',
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: isMobile ? 'column' : 'row',
                                            position: 'relative',
                                            cursor: 'pointer',
                                            zIndex: 2
                                        }}
                                        onClick={() => navigate(img.link)}
                                    >
                                        <div style={{ flex: 1 }} />
                                        <div
                                            style={{
                                                flex: 1,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'flex-end',
                                                alignItems: 'flex-start',
                                                textAlign: 'left',
                                                color: 'white',
                                                height: '100%',
                                                marginLeft: isMobile ? '24px' : '40px',
                                                paddingBottom: isMobile ? '24px' : '72px',
                                                textDecoration: 'none',
                                                zIndex: 4
                                            }}
                                        >
                                            <h1 style={{
                                                margin: 0,
                                                fontWeight: 200,
                                                lineHeight: '32px',
                                                marginBottom: '10px',
                                                color: 'white'
                                            }}>
                                                {img.title}
                                            </h1>
                                            <span
                                                style={{
                                                    color: 'white',
                                                    textDecoration: 'underline',
                                                    fontSize: '10px',
                                                    lineHeight: '13px',
                                                    marginBottom: '72px',
                                                    cursor: 'pointer',
                                                    textUnderlineOffset: '2px',
                                                    zIndex: 5
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    navigate(img.link);
                                                }}
                                            >
                        READ MORE
                    </span>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        })}

                    </Swiper>

                    {!isMobile && (
                        <div className="carousel-arrows" style={{
                            zIndex: 3,
                            position: 'absolute',
                            top: '50%',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between',
                            transform: 'translateY(-50%)',
                            pointerEvents: 'none'
                        }}>
                            <button
                                className="arrow"
                                onClick={goToPrevious}
                                style={{ pointerEvents: 'auto', background: 'transparent', border: 'none', cursor: 'pointer' }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                     fill="none" stroke="#ffffff" strokeWidth="2" viewBox="0 0 24 24">
                                    <path d="M15 18l-6-6 6-6" />
                                </svg>
                            </button>
                            <button
                                className="arrow"
                                onClick={goToNext}
                                style={{ pointerEvents: 'auto', background: 'transparent', border: 'none', cursor: 'pointer', marginRight: '20px', paddingRight: '30px' }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                     fill="none" stroke="#ffffff" strokeWidth="2" viewBox="0 0 24 24">
                                    <path d="M9 6l6 6-6 6" />
                                </svg>
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default Home;
